import { IDescriptionElement } from "../types/IDescriptionElement";

export const aboutUsContent: IDescriptionElement = {
  title: "O nas",
  text: "W naszej nowoczesnej klinice stomatologicznej priorytetem jest zdrowie i piękny uśmiech pacjentów. Oferujemy kompleksową opiekę stomatologiczną, łącząc zaawansowane technologie z indywidualnym podejściem do każdego pacjenta. Dbamy o komfort i bezpieczeństwo, zapewniając relaksującą atmosferę oraz nowoczesne znieczulenie. Zespół doświadczonych specjalistów dostosowuje rozwiązania do potrzeb i oczekiwań każdego pacjenta, gwarantując najwyższą jakość usług. Powierz nam swój uśmiech – zadbamy o niego z pełnym zaangażowaniem!",
  color: "blue",
};
